<template>
  <router-link
    class="d-pl16 d-w216"
    title="Dialtone homepage"
    to="/"
  >
    <dt-stack>
      <svg-loader name="dialtone-logo" />
    </dt-stack>
  </router-link>
</template>
